import { ClientItem, StampedLanguage } from 'owa-mail-store';
import ExtendedPropertyType from 'owa-service/lib/contract/ExtendedPropertyType';
import Item from 'owa-service/lib/contract/Item';
import { trace } from 'owa-trace';
import {
    ENTITY_ID_KEY,
    LANGUAGE_KEY,
    LOCALE_KEY,
    LANGUAGE_SCORES_KEY,
    DETECTED_LANGUAGE_PROPERTY_NAME,
} from './constants';

export default function getStampedLanguage(item: ClientItem): StampedLanguage {
    const extendedProperty = getDetectedLanguagePropertyFromItem(item);
    let locale: string = undefined;
    let language: string = undefined;
    let confidenceScore: number = 0;
    let entityId: string = undefined;

    try {
        if (extendedProperty) {
            // Extended property is present, parse and return the locale.
            const parsedProperty = JSON.parse(extendedProperty.Value)[0];
            const languageObj = parsedProperty[LANGUAGE_KEY];
            const languageScoresObj = parsedProperty[LANGUAGE_SCORES_KEY];

            entityId = parsedProperty[ENTITY_ID_KEY];
            language = Object.keys(languageScoresObj)[0];
            locale = languageObj?.[LOCALE_KEY] && languageObj[LOCALE_KEY].toLowerCase();
            confidenceScore = parseInt(Object.values(languageScoresObj)[0]);
        }
    } catch (e) {
        trace.info(`[getStampedLanguage] Failed to parse property, error: ${e.message}`);
    }

    return {
        locale: locale,
        language: language,
        confidenceScore: confidenceScore,
        entityId: entityId,
    };
}

function getDetectedLanguagePropertyFromItem(item: Item): ExtendedPropertyType {
    const extendedProperties = item.ExtendedProperty;
    if (extendedProperties) {
        const filteredProperties: ExtendedPropertyType[] = extendedProperties.filter(
            property => property.ExtendedFieldURI.PropertyName === DETECTED_LANGUAGE_PROPERTY_NAME
        );

        // We expect only one property to be present
        if (filteredProperties.length > 0) {
            return filteredProperties[0];
        }
    }

    return null;
}
